import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class BaggageStatsAdminService extends BaseService<any> {
  constructor() {
    super("baggage-stats");
  }

  // Аналитика багажной системы. params: { from?, to?, branchID?, stationID? }
  getStats = (params: Record<string, string> = {}) => {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v) as [string, string][],
    ).toString();
    return appAxios.get(`${this.pathWithOrg()}${qs ? `?${qs}` : ""}`);
  };

  // Аналитика маршрутов (OD-матрица + баланс направлений).
  // params: { from?, to?, branchID?, trainID?, minTrips?, collapseDirections?, sort? }
  getRouteStats = (params: Record<string, string> = {}) => {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v) as [string, string][],
    ).toString();
    return appAxios.get(`${this.pathWithOrg()}/routes${qs ? `?${qs}` : ""}`);
  };

  // Детализация одного маршрута (метрики + динамика по дням + разбивка по поездам).
  getRouteDetail = (
    originID: string,
    destinationID: string,
    params: Record<string, string> = {},
  ) => {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v) as [string, string][],
    ).toString();
    return appAxios.get(
      `${this.pathWithOrg()}/routes/${encodeURIComponent(originID)}/${encodeURIComponent(
        destinationID,
      )}${qs ? `?${qs}` : ""}`,
    );
  };
}

export default new BaggageStatsAdminService();
